import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientEmployeeDynamicFormComponent } from './client-employee-dynamicform.component';
const routes: Routes = [{ path: '', component: ClientEmployeeDynamicFormComponent }];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientEmployeeDynamicFormRoutingModule { }
